module.exports = __webpack_public_path__ + "static/media/work-img4.6c4d5c83.jpg";